import { fabric } from 'fabric';

class CanvasMapper {
  isCreated() {
    return !!this.canvas;
  }

  createItems(items) {
    for (const item of items) {
      this.add(item);
    }

    this.canvas.renderAll();
  }

  create(img, { original_width }) {
    this.canvas = new fabric.Canvas('mapper-canvas');

    this.canvas.setWidth(img.width);
    this.canvas.setHeight(img.height);

    const img_display_width = 900;

    this.xfactor = original_width / img_display_width;

    // this.canvas.on('object:selected', e => {
    //   const obj = e.target;
    //   console.log(obj);
    // });

    // this.canvas.on('selection:created', onCreated);
    // this.canvas.on('selection:updated', onUpdated);
    // this.canvas.on('selection:cleared', onCleared);
  }

  hideAll() {
    const objs = this.canvas.getObjects();
    for (const obj of objs) {
      obj.opacity = 0;
    }

    this.canvas.renderAll();
  }

  show(id) {
    const obj = this.find(id);

    this.canvas.setActiveObject(obj);
    this.canvas.bringToFront(obj);
    this.canvas.renderAll();
  }

  find(id) {
    const objs = this.canvas.getObjects();
    return objs.find(o => o.id === id);
  }

  findIndex(id) {
    const objs = this.canvas.getObjects();
    return objs.findIndex(o => o.id === id);
  }

  add(data) {
    const item = {
      left: 0,
      top: 0,
      opacity: 0.7,
      width: 200,
      height: 30,
      title: data.name,
      objectCaching: false,
      ...data,
    };

    const rect = new fabric.Rect(item);

    rect.on('mousedown', e => {
      const template_fields = document.querySelector('#template-fields-input');
      template_fields.dispatchEvent(new CustomEvent('OCRItemSelected', { detail: e.target }));
    });

    this.canvas.add(rect);
    this.canvas.renderAll();
  }

  getObjects() {
    const objs = this.canvas.getObjects();
    return objs.map(o => {
      return {
        id: o.id,
        title: o.title,
        name: o.name,
        left: o.left,
        top: o.top,
        width: o.width * o.scaleX,
        height: o.height * o.scaleY,
        config: o.config,
        coords: this.getObjCoords(o),
      };
    });
  }

  getObjCoords(obj) {
    const xfactor = this.xfactor;
    const ocoords = obj.oCoords;
    const top_left = ocoords.tl;
    const bottom_right = ocoords.br;
    const tl = [Math.round(top_left.x * xfactor), Math.round(top_left.y * xfactor)];
    const br = [Math.round(bottom_right.x * xfactor), Math.round(bottom_right.y * xfactor)];

    return [tl, br].join(',');
  }
}

export default CanvasMapper;
